export enum ApBaseWizardSteps {
  Selection = 'Selection',
  Details = 'Details',
  Overview = 'Overview'
}
